<template>
  <div class="threeContent">
    <div class="header">
      <div class="title">
        <span></span>
        三层任务
      </div>
      <usage ref="usage"></usage>
      <div class="right">
        <a
          href="#"
          @click.prevent="createServerTask"
          class="blue-btn"
        >
          <img
            src="@/assets/img/icon/u3156.svg"
            alt=""
          />
          服务器任务</a>
        <a
          href="#"
          @click.prevent="createClientTask"
          class="blue-btn"
        >
          <img
            src="@/assets/img/icon/u3156.svg"
            alt=""
          />
          客户机任务</a>
        <a
          href="#"
          @click.prevent="toFileManage"
          class="default-btn"
        >
          文件管理</a>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="table-content">
      <table-list
        ref="tableList"
        @pagechange="getTableList"
        @delAllTask="delAllTask"
        @rulesStatusAlls="rulesStatusAlls"
        @refresh="refresh"
        @openRule="openRule"
        @showTask="showTask"
        :table-list="tableData.list"
        :loading="loading"
      ></table-list>
    </div>
    <create-task
      ref="createTask"
      @getUsage="getUsage"
    ></create-task>
    <show-task />
  </div>
</template>

<script>
// 网吧列表
import TableList from "./TableList";
import CreateTask from "./modal/createTask";
import ShowTask from "./modal/showTask";
import usage from "./modal/usage";
import {
  getTableList,
  delTask,
  disableOrenable,
} from "@/requests/threeTierMission";
export default {
  name: "threeTierMission",
  components: {
    TableList,
    CreateTask,
    usage,
    ShowTask
  },
  data() {
    return {
      total: 0,
      page: 1,
      tableData: {
        list: [],
      },
      tableDataa: {
        list: [
          {
            accountType: 0,
            beginHour: 8,
            beginMinute: 0,
            bhideWindow: 0,
            brepeat: 0,
            createBy: "zy568156102",
            createTime: "2020-07-07T16:00:42",
            disabled: false,
            fileId: 417,
            fileName: "ProcessHacker.exe",
            fileSize: 1719840,
            localFilePath: "",
            modifyTime: "2020-07-07T16:02:48",
            nweekDaylist: 0,
            param: "",
            passportId: null,
            releaseDetails: "0台/1台",
            releaseProgress: 0,
            runType: 1,
            superRun: 0,
            taskId: 766,
            taskName: " te",
            taskType: 1,
            url: "",
            useFlow: 0
          }
        ]
      },
      loading: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getTableList(1);
      vm.$refs.usage.getUsage();
    });
  },
  mounted() {
    //监听键盘按键事件
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          window.$Message.hide();
        }
      })
    })
  },
  methods: {
    // 获取所有网吧列表
    async getTableList(current) {
      this.loading = true;
      let res = await getTableList({
        current,
        size: 30,
      });
      this.loading = false;
      this.tableData.list = res.data.records;
      this.total = parseInt(res.data.total);
      this.page = parseInt(res.data.current);
    },
    refresh(page) {
      if (page) {
        this.getTableList(page);
      } else {
        this.getTableList(this.page);
      }
    },
    getUsage() {
      this.$refs.usage.getUsage();
    },
    delAllTask() {
      if (this.$refs.tableList.selectedTaskIds().length == 0) {
        return window.$Message.show({
          title: "提示",
          type: "error",
          msg: "请选择任务",
        });
      }
      window.$Message.show({
        title: "删除任务",
        type: "error",
        msg: "确定将选中的任务删除掉吗？",
        cancleBtn: true,
        confirmFn: async () => {
          let res = await delTask({
            taskId: this.$refs.tableList
              .selectedTaskIds()
              .join(","),
          });
          if (res.code === 200) {
            window.$Message.hide();
            this.getTableList(
              this.$del.delPage(
                this.total,
                this.$refs.tableList.selectedTaskIds().length,
                30,
                this.page
              )
            );
          } else {
            window.$Message.hide();
            setTimeout(() => {
              window.$Message.show({
                title: "删除任务",
                type: "error",
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide();
                  window.$Message.confirmFn = null;
                },
              });
            }, 100);
          }
        },
      });
    },
    rulesStatusAlls(val) {
      let text;
      if (val == 1) {
        text = "启用";
      } else {
        text = "禁用";
      }
      if (this.$refs.tableList.selectedTaskIds().length == 0) {
        return window.$Message.show({
          title: "提示",
          type: "error",
          msg: "请选择任务",
        });
      }
      window.$Message.show({
        title: text + "任务",
        type: "error",
        msg: "确定将选中的任务" + text + "吗？",
        cancleBtn: true,
        confirmFn: async () => {
          let res = await disableOrenable({
            taskId: this.$refs.tableList
              .selectedTaskIds()
              .join(","),
            type: val,
          });
          if (res.code === 200) {
            window.$Message.hide();
            this.getTableList(this.page);
          } else {
            window.$Message.hide();
            setTimeout(() => {
              window.$Message.show({
                title: text + "任务",
                type: "error",
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide();
                  window.$Message.confirmFn = null;
                },
              });
            }, 100);
          }
        },
      });
    },
    async openRule(id, val) {
      let res = await disableOrenable({
        taskId: id,
        type: val,
      });
      if (res.code === 200) {
        this.getTableList(this.page);
      } else {
        /* eslint-disable */
        console.log(res.msg);
      }
    },
    async createServerTask() {
      let res = await window.$modal.createTaskModal.show(0);
      if (res) {
        this.getTableList(1);
        this.$refs.usage.getUsage();
      }
    },
    async createClientTask() {
      let res = await window.$modal.createTaskModal.show(1);
      if (res) {
        this.getTableList(1);
        this.$refs.usage.getUsage();
      }
    },
    toFileManage() {
      this.$router.push({
        path: this.$PAGE_API.home.children.fileManage.path,
      });
    },
    async showTask(item) {
      let res = await window.$modal.showTaskModal.show(item.taskType, item);
    }
  },
};
</script>

<style lang="scss" scoped>
.threeContent {
  position: absolute;
  min-width: 1140px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  overflow-y: auto;
}
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
  .title {
    float: left;
    font-size: 14px;
    span {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: #0099cc;
      position: relative;
      top: 2px;
    }
  }
}
.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}
.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;
  > div {
    display: inline-block;
  }
}
</style>
